var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3272_96041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4116 13.6252C15.5154 13.5561 15.6349 13.514 15.7591 13.5027C15.8834 13.4914 16.0085 13.5113 16.1231 13.5606L20.5444 15.5415C20.6934 15.6052 20.8177 15.7154 20.8989 15.8557C20.98 15.9959 21.0135 16.1587 20.9944 16.3196C20.8487 17.4081 20.3127 18.4066 19.486 19.1295C18.6593 19.8524 17.5982 20.2505 16.5 20.2496C13.1185 20.2496 9.87548 18.9063 7.48439 16.5152C5.0933 14.1241 3.75 10.8811 3.75 7.49961C3.74916 6.40143 4.1472 5.34032 4.87009 4.51361C5.59298 3.68691 6.59152 3.15089 7.68 3.00524C7.84091 2.98612 8.00368 3.01963 8.14395 3.10075C8.28422 3.18187 8.39444 3.30624 8.45813 3.45524L10.4391 7.88024C10.4877 7.99389 10.5076 8.11781 10.4968 8.24098C10.486 8.36414 10.4449 8.48272 10.3772 8.58618L8.37375 10.9684C8.30269 11.0756 8.26066 11.1994 8.25179 11.3278C8.24291 11.4561 8.26749 11.5846 8.32313 11.7006C9.09844 13.2877 10.7391 14.9087 12.3309 15.6765C12.4475 15.7319 12.5766 15.7559 12.7053 15.7462C12.834 15.7365 12.958 15.6934 13.065 15.6212L15.4116 13.6252Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3272_96041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.8ebc450b444d3c64b2fe15082c8803d2.svg";
export { ForwardRef as ReactComponent };